import type { ReactNode } from "react";
import "./ui.css";

interface EmptyStateProps {
	tone?: "light" | "bare" | "forest";
	icon?: ReactNode;
	title: string;
	description?: string;
	action?: ReactNode;
}

/* Default tone is "light" (normal surface). The "forest" dark card is for
   dashboard/firm/auth only — a dark card on a functional page reads as an
   error.

   "bare" is the same typography with no card: use it when the empty state is
   already inside a surface (a table body, a panel, a modal). A bordered card
   nested inside another bordered container reads as a rendering bug. */
export function EmptyState({
	tone = "light",
	icon,
	title,
	description,
	action,
}: EmptyStateProps) {
	return (
		<div className={`ui-empty ui-empty-${tone}`}>
			{icon && <div className="ui-empty-icon">{icon}</div>}
			<p className="ui-empty-title">{title}</p>
			{description && <p className="ui-empty-desc">{description}</p>}
			{action && <div className="ui-empty-action">{action}</div>}
		</div>
	);
}
